<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <formly-form
    [hidden]="!write"
    [form]="form"
    [fields]="fields"
    [options]="options"
    [model]="model"
  ></formly-form>
  <button
    *ngIf="write"
    nbButton
    status="primary"
    type="submit"
    nbButton status="primary"
    [disabled]="!form.valid"
    i18n="@@Save"
  >
    Сохранить
  </button>
  &nbsp;
  <button
    *ngIf="isModal && write"
    (click)="modalClose()"
    nbButton
    status="basic"
    type="button"
    nbButton status="primary"
    i18n="@@Close"
  >
    Закрыть
  </button>

  <button
    [routerLink]="absolutePath"
    nbButton
    status="basic"
    type="button"
    nbButton status="primary"
    i18n="@@Cancel"
    *ngIf="showListButton && write"
  >
    Отмена
  </button>
</form>
